export class YoutubePlayerReadyBus {
    private youtubeAPIisReallyReady = false;

    private subscribers: (() => void)[] = [];

    constructor() {
        window.onYouTubePlayerAPIReady = () => {
            this.youtubeAPIisReallyReady = true;
            this.subscribers.forEach((callback) => callback());
        };
    }

    public subscribe(callback: () => void) {
        if (this.youtubeAPIisReallyReady) {
            callback();
        } else {
            this.subscribers.push(callback);
        }
    }
}
